var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCheckCircleGreen60N1024Px = function SvgIcCheckCircleGreen60N1024Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.953 23.906c6.54 0 11.953-5.425 11.953-11.953C23.906 5.414 18.481 0 11.941 0 5.414 0 0 5.414 0 11.953c0 6.527 5.426 11.953 11.953 11.953Z",
    fill: "#1ED45A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.64 17.684c-.398 0-.726-.165-1.03-.575L6.667 13.5c-.176-.234-.281-.492-.281-.762 0-.527.41-.96.937-.96.34 0 .598.105.89.492l2.38 3.07 5.004-8.04c.222-.35.527-.538.832-.538.515 0 .996.351.996.902 0 .258-.153.527-.293.774l-5.508 8.671c-.246.387-.586.575-.984.575Z",
    fill: "#111213"
  })));
};
export default SvgIcCheckCircleGreen60N1024Px;